import {
  CheckCircleOutlined,
  ExclamationCircleOutlined,
  WarningOutlined,
} from '@ant-design/icons';
import { UploadResult } from '../../../store/reducers/OutgoingCallsUploadSlice';
import styles from './style.module.css';

export type UploadStatus = 'idle' | 'loading' | 'success' | 'warning' | 'error';

interface UploadResultBannerProps {
  status: UploadStatus;
  result: UploadResult | null;
}

export const UploadResultBanner = ({
  status,
  result,
}: UploadResultBannerProps) => {
  if (status === 'success' && result) {
    return (
      <div className={styles.resultBanner}>
        <CheckCircleOutlined className={styles.resultIconSuccess} />
        <div className={styles.resultText}>
          <span className={styles.resultTitle}>Загрузка завершена</span>
          <span className={styles.resultDescription}>
            Загружено {result.uploaded} из {result.total} заданий
          </span>
        </div>
      </div>
    );
  }

  if (status === 'warning' && result) {
    return (
      <div className={styles.resultBanner}>
        <WarningOutlined className={styles.resultIconWarning} />
        <div className={styles.resultText}>
          <span className={styles.resultTitle}>Загрузка завершена</span>
          <span className={styles.resultDescription}>
            Загружено 0 из {result.total} заданий
          </span>
        </div>
      </div>
    );
  }

  if (status === 'error') {
    return (
      <div className={styles.resultBanner}>
        <ExclamationCircleOutlined className={styles.resultIconError} />
        <div className={styles.resultText}>
          <span className={styles.resultTitle}>Ошибка</span>
          <span className={styles.resultDescription}>
            При загрузке файла произошла ошибка. Обратитесь в поддержку
          </span>
        </div>
      </div>
    );
  }

  return null;
};
